import React from "react";
import { Box, Typography } from "@mui/material";

interface DrawerHeaderProps {
  title: string;
  subtitle?: string;
  datasetName?: string | null;
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  title,
  subtitle,
  datasetName,
}) => (
  <Box
    sx={{
      p: 2,
      borderBottom: 1,
      borderColor: "divider",
    }}
  >
    <Typography className="font-bold" variant="h6">
      Edit Scorecard
    </Typography>
    {title && <Typography variant="body1">{title}</Typography>}
    {subtitle && (
      <Typography variant="body2" color="text.secondary">
        {subtitle}
      </Typography>
    )}
    {datasetName && (
      <Typography variant="caption" color="text.secondary">
        Dataset: {datasetName}
      </Typography>
    )}
  </Box>
);

export default DrawerHeader;
